"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interactableHeight = void 0;
const interactableHeight = {
  xSmall: {
    regular: 44,
    compact: 36
  },
  small: {
    regular: 48,
    compact: 36
  },
  medium: {
    regular: 52,
    compact: 40
  },
  large: {
    regular: 56,
    compact: 40
  },
  xLarge: {
    regular: 56,
    compact: 44
  },
  xxLarge: {
    regular: 60,
    compact: 44
  },
  xxxLarge: {
    regular: 64,
    compact: 48
  }
};
exports.interactableHeight = interactableHeight;